import React from 'react';
import PopUp from '../PopUp';

const ResultsHeader = ({ growthText, growthVal, heightText, heightVal, byAge, popUpLink, popUpModal }) => {
    return (
        <>
            <div className="results-header">
                <p>{growthText}</p>
                <span className="btn ghost">{growthVal}</span>
            </div>
        </>
        
    );
};

export default ResultsHeader;
